import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { styleClasses } from "@redotech/redo-web/styles";
import { Text } from "@redotech/redo-web/text";
import classNames from "classnames";
import { memo } from "react";
import { OnboardingProps } from "../common";

export const SupportV2NewLookModal = memo(function SupportV2NewLookModal({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoModal
      modalSize="sm"
      onModalCloseRequested={handleDismiss}
      primaryButton={{ text: "Got it", onClick: handleComplete, size: "sm" }}
      title="Support has a new look"
    >
      <Flex dir="column" gap="lg">
        <Text fontSize="sm" textColor="secondary">
          Love it? Missing something? Tap the &quot;Feedback&quot; button in the
          top right corner anytime to let us know.
        </Text>
        <Text fontSize="sm" textColor="secondary">
          If you have any questions about what&apos;s new or how to get started,
          check out our{" "}
          <a
            className={classNames(
              styleClasses({
                textColor: "tertiary",
                hoverTextColor: "secondary",
                textDecoration: "underline",
              }),
            )}
            href="https://help.getredo.com/en/collections/15906036-helpdesk"
            rel="noopener noreferrer"
            target="_blank"
          >
            help articles
          </a>
          .
        </Text>
      </Flex>
    </RedoModal>
  );
});
